<template>
  <div class="r-father">

    <!-- Search -->
    <div class="row mt-4">
      <div class="col-md-8">
        <input
            class="input form-control"
            @keypress.enter="find()"
            v-model="query.generic"
            placeholder="Pesquisar por conteúdo da linha"
        >
        <SearchIcon @click="find()" class="icon icon-within"/>
      </div>

      <button
          v-if="false"
          class="col-md-1 ml-2 btn-sm btn-outline"
          :class="{ 'btn-outline-active': showFilter }"
          @click="showFilter = !showFilter"
      >
        Filtros
        <ChevronDownIcon class="fa-angle-right" :class="{'rotate-90': showFilter }"/>
      </button>

      <button v-if="changeQuery" @click="find()" class="btn btn-link">
        Aplicar filtros ({{ numberOfBadges }})
      </button>
    </div>
  
    <div class="row mt-4">
      <div class="col-md-12">
        <strong>
          {{infoTotalModels}}
        </strong>
      </div>
    </div>
    
    <table class="r-table">
      <thead>
        <tr>
          <th v-for="column in columns" :key="column.id">
            {{ column.name }}
          </th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in rows" :key="rowIndex">
          <td v-for="(field, fieldIndex) in row.fields" :key="fieldIndex">
            <Field
              :column="columns[fieldIndex]"
              :field="field"
              :isTableOwner="isTableOwner"
              :table="table"
              @toJump="toJump(rowIndex, fieldIndex, $event)"
            />
          </td>
          <td class="text-center nowrap" style="position: relative">
            <InfoIcon
                class="r-icon mr-2"
                title="Detalhes"
                size="1.5x"
                @click="showRow(row)"
            />
            <XCircleIcon
                v-if="isTableOwner"
                class="r-icon"
                title="Remover linha"
                size="1.5x"
                @click="removeRow(row.id)"
            />
            <RowInfo
                v-if="showRowInfo && currentRow === row"
                :row="currentRow"
                :table="table"
                @closed="showRowInfo = false"
            />
          </td>
        </tr>
      </tbody>
    </table>
  
    <div class="row">
      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>
  
    <div class="row" v-if="!meta.nextPage">
      <div class="col-md-12 text-center">
        <button
            v-if="isTableOwner"
            class="btn btn-sm btn-outline mt-1"
            @click="addRow"
        >
          Nova linha
        </button>
      </div>
    </div>
    
  </div>
</template>

<script>
import Field from '@/components/custom_table/table/Field'
import Pagination from '@/components/shares/specialTag/Pagination'
import ModelMapper from '@/mixins/ModelMapper'
import RowInfo from './RowInfo.vue'
import { ChevronDownIcon, InfoIcon, SearchIcon, XCircleIcon } from 'vue-feather-icons'

const offTheEdge = ({ send, rowIndex, fieldIndex, rowSize, fieldSize }) => {
  const topLeft = (send === 'up' || send === 'left') &&
                  rowIndex === 0 && fieldIndex === 0
  
  const downRight = (send === 'down' || send === 'right') &&
                    (rowIndex + 1) === rowSize &&
                    (fieldIndex + 1) === fieldSize
  
  return  topLeft || downRight
}

const nextPosition = (position) => {
  if (position.send === 'up' && position.rowIndex === 0) {
    position.rowIndex = position.rowSize - 1
    position.fieldIndex--
  } else if (position.send === 'up') {
    position.rowIndex--
  } else if (position.send === 'right' && (position.fieldIndex + 1) === position.fieldSize) {
    position.rowIndex++
    position.fieldIndex = 0
  } else if (position.send === 'right') {
    position.fieldIndex++
  } else if (position.send === 'down' && (position.rowIndex + 1) === position.rowSize) {
    position.rowIndex = 0
    position.fieldIndex++
  } else if (position.send === 'down') {
    position.rowIndex++
  } else if (position.send === 'left' && position.fieldIndex === 0) {
    position.rowIndex--
    position.fieldIndex = position.fieldSize - 1
  } else if (position.send === 'left') {
    position.fieldIndex--
  }
}

export default {
  components: { ChevronDownIcon, Field, InfoIcon, Pagination, RowInfo, SearchIcon, XCircleIcon },
  computed: {
    columns() {
      return this.table.columns
    },
    isLastRow() {
      return !this.meta.nextPage && this.meta.perPage === this.rows.length
    },
    rows() {
      return this.getModels || []
    }
  },
  created() {
    this.defaultModelSetting.updateQueryURL = true
    this.asyncTemplateSelect({
      after: ({models}) => this.setEditableInFields(models),
      byURL: true,
      pagination: true,
    })
  },
  data: () => ({
    currentRow: null,
    nameModel: 'Row',
    showRowInfo: false,
  }),
  methods: {
    addRow() {
      this.openLoad()
      this.axios.post(`custom_table/tables/${this.table.id}/rows`)
        .then(response => {
          if (this.isLastRow) {
            this.params.page = this.meta.currentPage + 1
            this.find(true)
          } else {
            const row = response.data
            row.fields.forEach(field => this.$set(field, '_editable', false))
            this.models.push(row)
          }
        })
        .finally(() => this.closeLoad())
    },
    buildPath() {
      return `custom_table/tables/${this.table.id}/rows`
    },
    find(pagination = false) {
      this.asyncTemplateSelect({
        after: ({models}) => this.setEditableInFields(models),
        pagination,
      })
    },
    pagination(page) {
      this.params.page = page
      this.find(true)
    },
    removeRow(rowId) {
      if (!(confirm('Tem certeza?')))
        return
      
      this.openLoad()
      this.axios.delete(`custom_table/tables/${this.table.id}/rows/${rowId}`)
        .then(() => {
          if (this.params.page && this.meta.count === 1)
            this.params.page = this.params.page - 1
  
          this.find(true)
        })
        .catch(e => this.$notify.addError(e))
        .finally(() => this.closeLoad())
    },
    setEditableInFields(rows) {
      rows.forEach(row => {
        row.fields.forEach(field => this.$set(field, '_editable', false))
      })
    },
    showRow(row) {
      this.currentRow = row
      this.showRowInfo = true
    },
    toJump(rowIndex, fieldIndex, send) {
      const position = {
        fieldIndex,
        fieldSize: this.columns.length,
        rowIndex,
        rowSize: this.rows.length,
        send,
      }
      
      if (offTheEdge(position))
        return
    
      this.rows[position.rowIndex].fields[position.fieldIndex]._editable = false
      nextPosition(position)
      this.rows[position.rowIndex].fields[position.fieldIndex]._editable = true
    }
  },
  mixins: [ModelMapper],
  name: 'Rows',
  props: {
    isTableOwner: {
      required: true,
      type: Boolean
    },
    table: {
      required: true,
      type: Object
    }
  }
}
</script>

<style scoped>
  .r-table{
    width:100%;
    border-collapse: collapse;
  }
  
  .r-table th{
    padding: 4px 8px;
  }
  
  .r-table td{
    padding: 0;
  }
  
  .r-table th, .r-table td{
    border: 1px solid #ccc;
  }
  
  .r-table td {
    height:20px;
    line-height:20px;
  }

  .r-icon {
    color: black;
    transition: color 700ms;
  }
  
  .r-icon:hover {
    color: gold;
    cursor: pointer;
    transition: color 300ms;
  }

</style>